import { z } from 'zod';
export const ErrorCodeSchema = z.enum([
    'VALIDATION_FAILED',
    'DISCOUNT_EXCEEDS_SUBTOTAL',
    'INVALID_CURRENT_PASSWORD',
    'INVALID_PASSWORD',
    'PASSWORD_UNCHANGED',
    'INVALID_DATE_RANGE',
    'UNAUTHENTICATED',
    'SESSION_EXPIRED',
    'INVALID_CREDENTIALS',
    'ACCOUNT_DISABLED',
    'FORBIDDEN',
    'BAD_ORIGIN',
    'NOT_FOUND',
    'PRODUCT_NOT_FOUND',
    'SALE_NOT_FOUND',
    'USER_NOT_FOUND',
    'CATEGORY_NOT_FOUND',
    'INSUFFICIENT_STOCK',
    'PRODUCT_INACTIVE',
    'ALREADY_VOIDED',
    'DUPLICATE_USERNAME',
    'DUPLICATE_NAME',
    'DUPLICATE_CODE',
    'CATEGORY_NOT_EMPTY',
    'CATEGORY_IN_USE',
    'DISCOUNT_RULE_NOT_FOUND',
    'LAST_ADMIN',
    'CANNOT_MODIFY_SELF',
    'UNSUPPORTED_MEDIA_TYPE',
    'IMAGE_TOO_LARGE',
    'UNSUPPORTED_IMAGE',
    'NO_ORIGINAL',
    'RATE_LIMITED',
    'INTERNAL',
]);
export const ApiErrorSchema = z.object({
    error: z.object({
        code: ErrorCodeSchema,
        message: z.string(),
        details: z.record(z.string(), z.unknown()).optional(),
    }),
});
export const OkResponseSchema = z.object({ ok: z.literal(true) });
//# sourceMappingURL=errors.js.map